








































import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import iwModal from "@/shared/components/Modal.vue";
import iwCustomerForm from "@/optimizedEncoding/components/contactInformation/customerForm/CustomerForm.vue";

import { validateForm } from "@/shared/scripts/ValidateForm";

import iwButtonLoading from "@/shared/components/ButtonLoading.vue";

// Interfaces
import { Customer } from "@/shared/interfaces/customer/Customer.interface";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { removeBillboardAndNotify } from "@/optimizedEncoding/scripts/helpers/billboardEligibility";

export default Vue.extend({
    components: {
        iwModal: iwModal,
        iwCustomerForm: iwCustomerForm,
        iwButtonLoading: iwButtonLoading
    },

    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
    },

    data: function() {
        return {
            isMobile: true as boolean,
            errors: null as unknown | Array<Record<string, unknown>>,
            isLoading: false,
        };
    },

    computed: {
        ...mapGetters({
            customerApiErrors: "CustomersModule/customerApiErrors",
            isMasquerading: "UserModule/isMasquerading",
        }),
        ...mapState("CustomersModule", ["currentCustomer"]),
        customer: function(): Customer|null {
            return this.$store.getters["FormModule/getValueUI"]("customer");
        },
        vatNumberError: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("vatNumberError");
        },
        isEditMode: function(): boolean {
            const customerToEdit = this.$store.getters["FormModule/getValueUI"]("customer.customerToEdit");
            if (customerToEdit) {
                return true;
            }
            return false;
        },
        buttonLabel: function(): string {
            if (this.isEditMode) {
                return this.$t("update_invoice_address").toString();
            }
            return this.$t("add_invoice_address").toString();
        }
    },

    created: function() {
        if (!this.isEditMode) {
            this.$store.commit("FormModule/deleteValueUI", "customer");
        }
    },
    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    methods: {
        ...mapActions("CustomersModule", ["createCustomer", "updateCustomer"]),

        closeModal: function() {
            this.$emit("closeModal");
        },
        createOrUpdateCustomer: function() {
            if (this.isEditMode) {
                this.updateEditedCustomer();
            } else {
                this.createNewCustomer();
            }
        },
        createNewCustomer: function() {

            // Validate form

            const customerForm = document.getElementById("newCustomerForm") as HTMLFormElement;
            if (!customerForm) { return; }

            const isFormValid = validateForm(customerForm);

            if (!isFormValid.value === true || this.vatNumberError) {
                return this.$store.commit("CustomersModule/setCustomerFormError", isFormValid.errors);
            }

            this.$store.commit("CustomersModule/resetCustomerFormError");

            if (!this.customer) { return; }

            // Send request

            this.isLoading = true;
            this.customer.isNew = true;
            this.createCustomer(this.customer).then(success => {
                if (success) {
                    // Creating an address is not "changing the billing address" — don't
                    // preemptively strip the billboard here. Removal/notify only happens
                    // when the user actually changes billing (selecting/editing an address).
                    this.closeModal();
                }
            })
                .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()))
                .finally(() => this.isLoading = false);
        },
        updateEditedCustomer: function() {
            // Validate form

            const customerForm = document.getElementById("newCustomerForm") as HTMLFormElement;
            if (!customerForm) { return; }

            const isFormValid = validateForm(customerForm);

            if (!isFormValid.value === true || this.vatNumberError) {
                return this.$store.commit("CustomersModule/setCustomerFormError", isFormValid.errors);
            }

            this.$store.commit("CustomersModule/resetCustomerFormError");

            if (!this.customer) { return; }

            this.isLoading = true;

            const customerToUpdate = this.customer.customerToEdit;
            customerToUpdate.location = this.customer.location;
            customerToUpdate.hasInvoicingEnabled = this.customer.hasInvoicingEnabled;
            if (this.customer.hasInvoicingEnabled) {
                customerToUpdate.vatNumber = this.customer.vatNumber;
                customerToUpdate.name = this.customer.name;
            }

            this.updateCustomer(customerToUpdate).then(success => {
                if (success) {
                    /*  updateClassified((success: boolean) => {
                        if (success) {
                            this.closeModal();
                        }
                    });  */
                    removeBillboardAndNotify();
                    this.closeModal();
                    this.isLoading = false;
                }
                
            }).catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()));
        }
    }
});

